export default {
  editingTitle: 'Editando menu de QR Code para {{name}}',
  creatingTitle: 'Criando menu de QR Code para {{name}}',
  creatingTitleAsset: 'Criando menu de QR Code para ativo',
  name: 'Nome*',
  level: 'Nível',
  assetTypes: 'Tipos de ativo*',
  assetPlaceLevel: 'Local associado ao ativo',
  assetTypesRequired: 'Obrigatório selecionar ao menos um tipo de ativo'
}
